import { create, type StateCreator } from 'zustand';

// FIXME 마땅히 어디에 인터페이스를 정의해야 할지 몰라. . 적절한 곳이 있다면 누구라도 옮겨주세요..
interface ITokenPayload {
  sub: string;
  exp: number;
  info: {
    channel: string;
    type: string;
    sex: string;
    idx: number;
    id: string;
    nk: string;
    dt: string;
    pf: string;
    iat: number;
    ip: string;
    lang: string[];
    lev?: number;
    rk?: number;
  };
  etc?: {
    mc: string;
  };
}

interface SocketState {
  token: string;
  setToken: (newToken: string) => void;
  channel: string;
  setChannel: (newChannel: string) => void;
  payloadInfo: (token: string) => null | ITokenPayload;
}

const store: StateCreator<SocketState, [], [], SocketState> = (set) => ({
  token: '',
  setToken: (newToken: string) => set(() => ({ token: newToken })),
  channel: '',
  setChannel: (newChannel: string) => set(() => ({ channel: newChannel })),
  payloadInfo: (token: string) => {
    if (!token) return null;
    try {
      const tokenSplit = token.split('.');
      const decodedTokenPayload = atob(tokenSplit[1]);

      return JSON.parse(decodedTokenPayload);
    } catch (_) {
      //
    }
  },
});

const useSocketStore = create<SocketState>()(store);

export default useSocketStore;
